import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import {
	Container,
	Input,
	Button,
	Form,
	Grid,
	Segment,
	Header,
	Message
} from "semantic-ui-react";
import { auth } from "../../firebase";

interface IState {
	email: string;
	error: string;
	emailStatus: string;
}

interface IProps extends RouteComponentProps<{}> {}
//  TODO => Customise the email sent
class ForgotPasswordPage extends React.Component<IProps, IState> {
	state = {
		email: "",
		error: "",
		emailStatus: ""
	};

	handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({
			[evt.currentTarget.name]: evt.currentTarget.value
		} as any);
	};

	handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
		const { email } = this.state;
		const URLHost =
			process.env.NODE_ENV === "production"
				? window.location.hostname
				: "localhost:3000";
		const actionCodeSettings = {
			// this will need to change in production
			url: "http://" + URLHost + "/login"
		};

		auth
			.sendPasswordResetEmail(email, actionCodeSettings)
			.then(success =>
				this.setState({
					emailStatus: "sent"
				})
			)
			.catch(error => {
				this.setState({
					error: error
				});
			});
	};

	render() {
		const { email } = this.state;
		const isInvalid = email === "";
		return (
			<Grid
				textAlign="center"
				style={{ height: "100%" }}
				verticalAlign="middle"
			>
				<Grid.Column style={{ maxWidth: 450 }}>
					<Form size="large" onSubmit={this.handleSubmit}>
						<Segment stacked>
							<Header as="h2" color="teal" textAlign="center">
								Forgot your password?
							</Header>
							{this.state.error && (
								<Message negative style={{ textAlign: "left" }}>
									Please check your email and try again
									{/* unhandled server error */}
								</Message>
							)}
							<Form.Input
								fluid
								icon="mail"
								iconPosition="left"
								placeholder="E-mail address"
								value={this.state.email}
								onChange={this.handleChange}
								name="email"
								type="text"
							/>
							{this.state.emailStatus && (
								<Message positive style={{ textAlign: "left" }}>
									An email has been sent to your address.
									Please click the link in the email to reset
									your password.
								</Message>
							)}
							<Button
								fluid
								size="large"
								type="submit"
								disabled={isInvalid}
							>
								Submit
							</Button>
						</Segment>
					</Form>
				</Grid.Column>
			</Grid>
		);
	}
}

export default ForgotPasswordPage;



// WEBPACK FOOTER //
// ./src/pages/ForgotPasswordPage/ForgotPasswordPage.tsx